module.exports = __webpack_public_path__ + "static/media/Pregnancy.86816709.png";